export default __webpack_public_path__ + "static/media/file_upload.d4438d4483d2908ece9742ce0475c9dc.svg";